export default "__VITE_ASSET__149ASFeb__"